


















































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';

import { EDITOR_WIDTH } from '@/store/dailyReport';

@Component
export default class IndexPageEditDialog extends Vue {

  @Prop() cancelText!: string;
  @Prop({ default: true }) isRemoveShown!: boolean;
  @Prop({ default: true }) isSaveShown!: boolean;
  @Prop({ default: false }) isRemoving!: boolean;
  @Prop() isSaving!: boolean;
  @Prop() saveText!: string;
  @Prop() savingText!: string;
  @Prop() title!: string;

  @Emit() cancel() { }
  @Emit() remove() { }
  @Emit() submit() { }

  EDITOR_WIDTH = EDITOR_WIDTH;

}
